import { combineReducers } from "redux";
import { connectRouter } from 'connected-react-router';
import { filters } from "../../store/filters/reducers";
import { search } from "../../store/search/reducers";
import { results } from "../../store/results/reducers";
import { content } from "../../store/content/reducers";
import { shortlist } from "../../store/shortlist/reducers";


export const rootReducers = history => combineReducers({
  router: connectRouter(history),
  filters,
  search,
  results,
  content,
  shortlist,
});
